import { render } from "./MemoTagList.vue?vue&type=template&id=b84cabd4&ts=true"
import script from "./MemoTagList.vue?vue&type=script&lang=ts"
export * from "./MemoTagList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__